import Component from '../classes/Component'

export default class extends Component {
  constructor (element) {
    super({
      classes: {},
      element: element,
      elements: {
        copy: '[data-copy]',
        facebook: '[data-facebook]',
        twitter: '[data-twitter]',
        linkedIn: '[data-linkedin]'
      }
    })
    this.url = 'https://impact.compassion.com.au'
    this.createSocialLinks()
  }

  createPopoutWindow (url) {
    const left = (window.innerWidth - 570) / 2
    const top = (window.innerHeight - 570) / 2
    const params = 'menubar=no,toolbar=no,status=no,width=570,height=570,top=' + top + ',left=' + left
    window.open(url, 'NewWindow', params)
  }

  createSocialLinks () {
    const pageUrl = encodeURIComponent(document.URL)
    const tweet = encodeURIComponent(document.querySelector("meta[property='og:description']").content)
    const hashtag = encodeURIComponent('#thegoodneighbour')

    this.elements.facebook.addEventListener('click', () => {
      const url = 'https://www.facebook.com/sharer.php?u=' + pageUrl + '&hashtag=' + hashtag
      this.createPopoutWindow(url)
    })

    this.elements.twitter.addEventListener('click', () => {
      const url = 'https://twitter.com/intent/tweet?url=' + pageUrl + '&text=' + tweet
      this.createPopoutWindow(url)
    })

    this.elements.linkedIn.addEventListener('click', () => {
      const url = 'https://www.linkedin.com/shareArticle?mini=true&url=' + pageUrl
      this.createPopoutWindow(url)
    })

    this.elements.copy.addEventListener('click', () => {
      navigator.clipboard.writeText(this.url)
    })
  }
}
